import { render, staticRenderFns } from "./Minha.vue?vue&type=template&id=19df1ce2&"
import script from "./Minha.vue?vue&type=script&lang=js&"
export * from "./Minha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports